'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _StoryEngine = require('../story/StoryEngine');

var _StoryEngine2 = _interopRequireDefault(_StoryEngine);

var _Background = require('../sprites/Background');

var _Background2 = _interopRequireDefault(_Background);

var _Lentilsoy = require('../sprites/Lentilsoy');

var _Lentilsoy2 = _interopRequireDefault(_Lentilsoy);

var _FishBowl = require('../sprites/FishBowl');

var _FishBowl2 = _interopRequireDefault(_FishBowl);

var _Telephone = require('../sprites/Telephone');

var _Telephone2 = _interopRequireDefault(_Telephone);

var _WhiteSquare = require('../sprites/WhiteSquare');

var _WhiteSquare2 = _interopRequireDefault(_WhiteSquare);

var _Desktop = require('../ui/Desktop');

var _Desktop2 = _interopRequireDefault(_Desktop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals __DEV__ */


var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {}
  }, {
    key: 'create',
    value: function create() {
      this.game.PLAYER_SCORE = 0;
      this.game.CHOICES = {};
      this.game.LOOPED_SOUNDS = {};

      this.background = new _Background2.default({
        game: this.game,
        x: this.world.centerX,
        y: this.world.centerY
      });
      this.game.add.existing(this.background);

      this.pulse = this.game.add.sprite(this.world.centerX - 68, this.world.centerY + 80, 'pulse');
      var pulse = this.pulse.animations.add("pulse");
      this.pulse.animations.play("pulse", 20, true);

      this.lentilsoy = new _Lentilsoy2.default({
        game: this.game,
        x: 230,
        y: this.world.height - 140
      });
      this.game.add.existing(this.lentilsoy);

      this.fishBowl = new _FishBowl2.default({
        game: this.game,
        x: 0,
        y: 0
      });
      this.fishBowl.y = 260;
      this.game.add.existing(this.fishBowl);

      this.fish = this.game.add.sprite(10, 280, 'fish');
      var bob = this.fish.animations.add("bob");
      this.fish.animations.play("bob", 20, true);
      this.fish.scale.setTo(0.7);

      this.telephone = new _Telephone2.default({
        game: this.game,
        x: 950,
        y: this.world.height - 240
      });
      this.game.add.existing(this.telephone);

      this.desktop = new _Desktop2.default({
        game: this.game
      });
      this.desktop.x = this.game.world.centerX;
      this.desktop.y = this.game.world.centerY - 10;
      this.game.add.existing(this.desktop);
      this.desktop.visible = false;

      this.modal = new _WhiteSquare2.default({
        game: this.game,
        x: this.game.world.centerX,
        y: this.game.world.centerY
      });
      this.modal.width = this.game.world.width;
      this.modal.height = this.game.world.height;
      this.modal.visible = false;
      this.game.add.existing(this.modal);

      this.storyEngine = new _StoryEngine2.default({
        game: this.game,
        storyJson: game.cache.getJSON('story')
      });
      this.storyEngine.loadStory();
      this.storyEngine.enableNodes();
    }
  }, {
    key: 'update',
    value: function update() {}
  }, {
    key: 'render',
    value: function render() {}
  }, {
    key: 'fade',
    value: function fade(color, duration) {
      this.FADE_COLOR = color;

      this.game.camera.onFadeComplete.addOnce(this.onFadeComplete, this);
      this.game.camera.fade(color, duration);
    }
  }, {
    key: 'onFadeComplete',
    value: function onFadeComplete() {
      this.modal.tint = this.FADE_COLOR;
      this.FADE_COLOR = undefined;

      this.modal.visible = true;
      this.game.camera.reset();
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Game.js
// module id = 341
// module chunks = 0